export interface ReportItem {
    name: string
    permission?: string
    zuggitOnly?: boolean
    link: string
}

export interface ReportCategory {
    category: string
    icon: string
    reports: ReportItem[]
}

export const REPORTS: ReportCategory[] = [
    {
        category: 'Dashboards',
        icon: 'fa-tachometer',
        reports: [
            {
                name: 'Branch Manager',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=e0f89834-9ffa-4b69-abe2-4410924b2af4&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'

            },
            {
                name: 'Service Manager',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=21add3d2-a7d2-4ab4-abb2-d52396a2314e&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'RVP',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=5e90b650-0683-43fe-945f-d6d38fffcfa9&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Construction',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=ca367773-da5e-4e21-8cab-b9e67324d9b1&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Purchasing',
                permission: 'purchaseDashboardReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=c1c61c84-eb69-406f-bc0d-682281b427ef&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&experience=power-bi'
            },
            {
                name: 'Warehouse',
                permission: 'warehouseDashboardReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=3e48a307-b538-431e-8087-70e1c94aee74&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&experience=power-bi'
            },
            {
                name: 'Zuggit Purchasing',
                permission: 'zuggitPurchasingDashboardReport',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=5f959b3d-9d38-4813-9fb6-c54eb24eaf45&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&experience=power-bi'
            }
        ],
    },
    {
        category: 'Invoice',
        icon: 'fa-dollar-sign',
        reports: [
            {
                name: 'Invoice Sales',
                permission: 'InvoiceSalesReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=ba38476e-063f-485a-ba41-c143e5b95553&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Invoice Sales 2',
                permission: 'InvoiceSalesSummary',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=7ab5761e-0191-4464-88a2-8d6ec1a0450d&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtaC1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9'
            },
            {
                name: 'AR with Notes',
                permission: 'ARReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=305536fa-1747-4383-aefb-607af03eca97&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Customer Sales',
                permission: 'CustomerSalesSummaryReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=fa31acee-36b8-4e1b-b0bd-c00bf8dae6b8&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Customer Payment',
                permission: 'CustomerPaymentReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=a7a4f8c6-b23a-403d-927d-b679a3d89b7b&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Invoice Created',
                permission: 'InvoiceCreatedReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=3dea5d63-c2f2-48a3-b27a-43cbfb10c1af&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Tax',
                permission: 'TaxReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=ec852269-fdb5-4c56-b0c8-68f8e9140a1d&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Active Dispute Widget',
                permission: 'TaxReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=992c5cb6-18ef-42d8-80a2-247df9e9985d&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Profitability Grouping',
                permission: 'InvoiceProfitabilityGroupingReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=4ed9064a-7632-4c60-9022-3a33cf6ea3c9&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Invoice Status History',
                permission: 'InvoiceStatusHistoryReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=08745072-16fc-4964-9e34-8cbb2e1d001e&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Zuggit Invoice Sales 2',
                permission: 'zuggitInvoiceSales2Report',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/reportEmbed?reportId=5f7182d9-714d-47f1-832d-8b258d62cb15&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Zuggit AR with Notes',
                permission: 'zuggitARNotesReport',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/reportEmbed?reportId=fa2c36fd-682d-4173-b243-c322186aa393&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Zuggit Customer Payment',
                permission: 'zuggitCustomerPaymentReport',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/reportEmbed?reportId=1f3ea229-56ac-445c-b481-d7d2d3283e7f&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Zuggit Invoice Created Summary with Details',
                permission: 'zuggitInvoiceCreatedSummaryReport',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/reportEmbed?reportId=b895c93e-1f0e-4761-b654-74779fea90ea&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            }
        ],
    },
    {
        category: 'Dispatch',
        icon: 'fa-phone',
        reports: [
            {
                name: 'Dispatch & Open Dispatch Summary',
                permission: 'OpenDispatchTicketReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=14e665fa-6202-4999-b06d-8c8336a20c7d&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Tech Hours',
                permission: 'TechHoursReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=882c28ef-68e8-48c6-9f64-2b80ef75bc9e&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Equipment History',
                permission: 'DispatchEquipmentHistory',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=8daae54a-6729-4e16-9374-569eef1efb9e&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Status History',
                permission: 'DispacthStatusHistoryReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=d6973eae-8621-4475-a5f9-2b60fefbdd10&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtaC1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9'
            },
            {
                name: 'Created',
                permission: 'DispatchCreatedReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=28f7e625-888a-4127-866c-b72edb8edc26&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Wrong Parts Requested',
                permission: 'WrongPartsRequested',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=def53277-15aa-4ee9-8d2c-be7b2209f941&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Employee Census',
                permission: 'EmpCensusReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=74dd4755-a3f6-447a-aa8c-dd9b480291fd&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Labor',
                permission: 'DispatchLaborReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=44c23f37-ac1c-4e07-a219-0cbc74fb6905&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Trips to Complete',
                permission: 'WeeklyServiceLaborReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=78e504dd-f7dc-4b35-ae25-483cdcaf1fa0&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Weekly Service Labor Report',
                permission: 'WeeklyServiceLaborReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=1be86819-c106-468d-9243-e62a372f685d&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Zuggit Dispatch & Open Dispatch Summary',
                permission: 'zuggitDispatchSummaryReport',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/reportEmbed?reportId=483c728a-2931-4d3e-bda2-76b0c99a9c72&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Zuggit Equipment History',
                permission: 'zuggitEquipmentHistoryReport',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/reportEmbed?reportId=9d87e31b-d497-4f96-ba8b-c39e656ebd5f&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Zuggit Wrong Parts Requested',
                permission: 'zuggitWrongPartsRequestedReport',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/reportEmbed?reportId=f7d80691-a84b-445e-8ce3-754c9ad740bd&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            }
        ]
    },
    {
        category: 'Construction',
        icon: 'fa-toolbox',
        reports: [
            {
                name: 'Dispatch PM Board Confirmations',
                permission: 'DispatchPMBoardConfirmations',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=b9defc36-377d-422e-baa5-d4d6453d0f27&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Post Construction Warranty Monthly Job',
                permission: 'PostConstructionWarrantyReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=50a886ef-d463-4b9a-9d27-7c460c5c2b7f&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            }
        ]
    },
    {
        category: 'Quote',
        icon: 'fa-quote-right',
        reports: [
            {
                name: 'Quote Summary',
                permission: 'QuoteSummary',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=b60c02f0-b8c9-44dc-a33a-b4255f96b304&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtaC1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9'
            },
            {
                name: 'Zuggit Quote Summary',
                permission: 'zuggitQuoteSummaryReport',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/reportEmbed?reportId=3795691c-d947-4cd5-aef1-4e33b0f4d10e&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
        ]
    },
    {
        category: 'Order',
        icon: 'fa-receipt',
        reports: [
            {
                name: 'Purchase Order',
                permission: 'POReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=0d64a2b1-1506-43d8-9a01-830f2135deb3&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Purchase Order Bill',
                permission: 'POReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=aae1892b-8614-4600-b61e-6180fcddc06a&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Wrong Parts Ordered',
                permission: 'POReport',
                zuggitOnly: false,
                link: "https://app.powerbi.com/reportEmbed?reportId=700589f0-82e2-44ce-80d7-a3198ed8a2ba&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
                name: 'Zuggit Purchase Order',
                permission: 'zuggitPurchaseOrderReport',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/reportEmbed?reportId=4b95164a-ef65-4793-a8b5-f196a97cef51&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Zuggit Purchase Order Bill',
                permission: 'zuggitPurchaseOrderBillReport',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/reportEmbed?reportId=39d0f41c-7fcd-456b-ae10-ef6d27a46b17&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Zuggit Wrong Parts Ordered',
                permission: 'zuggitWrongPartsOrderedReport',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/reportEmbed?reportId=31e201af-c4df-4892-9c28-8b63ce3f3060&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Zuggit Daily Received By Vendor Credit',
                permission: 'zuggitDailyReceivedByVendorCreditReport',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/reportEmbed?reportId=e2ecf89f-eff6-4a16-bb02-77ffd36c2d09&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
        ]
    },
    {
        category: 'Parts',
        icon: 'fa-box',
        reports: [
            {
                name: 'Inventory Quantity Cost',
                permission: 'InventoryQuantityCostReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=934baadb-aee2-4919-a582-3e2d74fbcb0e&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Inventory',
                permission: 'ARReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=558e7a74-828d-4a6b-bfdf-334e68add7b1&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Common Inventory',
                permission: 'CommonInventory',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=85e1a2bf-e19a-4ab7-aa4e-0ed5d0d1cbfc&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Part Cycle Count',
                permission: 'ARReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=5f87b4b1-1767-457b-a596-b8ca838ad0f7&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Part Bought/Sold',
                permission: 'PartBoughtSoldReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=f65c612c-ee2d-4bca-bb78-af42a657f95e&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Part Activity',
                permission: 'ARReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=65ea8304-afd2-4bfa-b697-3eaa4bf7f1f8&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Part Activity Unused Only',
                permission: 'ARReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=5f0029dc-9e50-4ac9-9474-06c68e1cd346&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Asset History',
                permission: 'AssetHistoryReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=eeea9a02-5470-4f35-b7d3-adec5c8514f6&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Inventory Thresholds',
                permission: 'InventoryThresholdsReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=ad832bff-11cb-4a6f-877a-6423afda02f5&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtaC1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9'
            },
            {
                name: 'Commit History',
                permission: 'CommonInventory',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=a74f480f-b706-4e6b-b074-a9a2ac7b079f&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Zuggit Inventory Quantity Cost',
                permission: 'zuggitInventoryQuantityCostReport',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/reportEmbed?reportId=b4cd9f1b-f79e-43f9-9a68-e6bb2e2c0898&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Zuggit Part Activity',
                permission: 'zuggitPartsActivityReport',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/reportEmbed?reportId=1b9df873-ff4f-4c7b-a8d1-07bc0feea79b&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Zuggit Part Bought/Sold',
                permission: 'zuggitPartBoughtSoldReport',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/reportEmbed?reportId=1cc96308-65ed-413c-b568-e8f5870de4aa&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Zuggit Supplier Query',
                permission: 'zuggitSupplierQueryReport',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/reportEmbed?reportId=deed256f-89f1-4f03-9d04-4bcfc54d4710&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Zuggit Daily Received By',
                permission: 'zuggitDailyReceivedByReport',
                zuggitOnly: true,
                link: 'https://app.powerbi.com/reportEmbed?reportId=baaaa039-77d6-4f5e-850d-bb385afcbe47&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            }
        ]
    },
    {
        category: 'Customer',
        icon: 'fa-building',
        reports: [
            {
                name: 'Customer Details',
                permission: 'InventoryThresholdsReport',
                zuggitOnly: false,
                link: 'https://app.powerbi.com/reportEmbed?reportId=d077e353-f621-463c-a533-e1d2ff00b458&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtaC1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9'
            }
        ]
    },
    {
        category: 'Employee',
        icon: 'fa-users',
        reports: [
            {
                name: 'Employee Breakdown',
                permission: 'EmpBreakdownReport',
                link: 'https://app.powerbi.com/reportEmbed?reportId=03336475-6512-429f-9fab-efc0b604560f&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            },
            {
                name: 'Employee Opportunities',
                permission: 'EmployeeErrorsReport',
                link: 'https://app.powerbi.com/reportEmbed?reportId=e586b2f7-9950-40af-a51a-d3c651426ee0&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Employee Kudos',
                permission: 'EmployeeErrorsReport',
                link: 'https://app.powerbi.com/reportEmbed?reportId=f6c560f1-11a9-435a-a769-d79369e282f6&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974'
            },
            {
                name: 'Labor Line/Union',
                permission: 'LaborLineUnionReport',
                link: 'https://app.powerbi.com/reportEmbed?reportId=2e79c80f-abff-44d3-bcb0-c6b16e20b6a9&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            }
        ]
    },
]
